import axios from "axios";

//IMPORT API ROUTE URL
import { GET_DASHBOARD_COUNTS_ROUTE } from "./apiRoutes";

const getDashboardCounts = (user_slug) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);

  return axios
    .post(GET_DASHBOARD_COUNTS_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getDashboardCounts;
